export const GHIN_REWIND_YEAR = "2023";
export const HIDE_GHIN_REWIND_BUTTONS = true;
